export default __webpack_public_path__ + "static/TSI-Trading_Standards-e08aeb49e84ac8f13ae05ba4d404f028.svg";